// libs
import React, { memo, useEffect, useState } from 'react';
import Loader from 'shared/components/Loader';

// components
import CartStyleTokens from 'shared/styles/CartStyleTokens';
import CartRoutes from './Routes';

function Cart() {
  const [showLoader, setShowLoader] = useState(true);

  useEffect(() => {
    setShowLoader(false);
  }, []);

  if (showLoader) {
    return <Loader />;
  }

  return (
    <>
      <CartStyleTokens />
      <CartRoutes />
    </>
  );
}

export default memo(Cart);
